export interface KngToaster {
  state: KngToasterState;
}
export interface KngToasterState {
  category: string;
  message: string;
}
